import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheIngenieurBigData = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🧱 Recruter un Ingénieur Big Data
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          L’Ingénieur Big Data conçoit et administre les architectures permettant de traiter des volumes massifs de données. Il rend possible l’analyse en temps réel, le stockage distribué, et l’exploitation efficace des données structurées et non structurées. Ce profil est indispensable dans les organisations data-driven, notamment pour les projets liés à l’IA, à l’IoT, ou à la personnalisation à grande échelle.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Définir et maintenir des architectures distribuées (Hadoop, Spark, Kafka…)</li>
          <li>Concevoir des pipelines d’ingestion, transformation et stockage de données massives</li>
          <li>Gérer la scalabilité, la performance et la sécurité des environnements Big Data</li>
          <li>Travailler sur des flux en temps réel et du batch processing</li>
          <li>Collaborer avec les équipes data science, BI et DevOps</li>
          <li>Automatiser le déploiement et la surveillance des traitements</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Frameworks : Hadoop, Spark, Flink, Kafka</li>
          <li>Bases de données : HDFS, Hive, HBase, Cassandra</li>
          <li>Langages : Scala, Python, Java, SQL</li>
          <li>Cloud & stockage : AWS EMR, GCP BigQuery, Azure HDInsight</li>
          <li>Outils de traitement distribué et gestion de workflow : Airflow, NiFi</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : bonne maîtrise des outils et pipelines simples</li>
          <li>Confirmé : gestion de clusters, performances et volumes complexes</li>
          <li>Senior / Architecte Big Data : conception d’écosystèmes data industriels, supervision d’équipe ou de projet à grande échelle</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 400–500 € / jour</li>
          <li>Confirmé : 550–750 € / jour</li>
          <li>Senior / Architecte : 800–1 000 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheIngenieurBigData;
